import { GsFormSchema } from '@gs/shared';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';

/**
 * The schema for the categories component form.
 * Defines the fields to display for the form.
 */

export const CROSS_ENTITY_TABS_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...ACTIVE_SCHEMA_FIELDS,
    {
      formControlName: 'title',
      label: 'components.crossEntityTabs.schema.title',
      type: 'text',
      default: 'components.crossEntityTabs.schema.defaultTitle',
      inputType: 'text'
    },
    {
      formControlName: 'showText',
      label: 'components.crossEntityTabs.schema.showName',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showText2',
      label: 'components.crossEntityTabs.schema.showCategory',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showPrice',
      label: 'components.crossEntityTabs.schema.showPrice',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showRating',
      label: 'components.crossEntityTabs.schema.showRating',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showPicture',
      label: 'components.crossEntityTabs.schema.showPicture',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showBasketButton',
      label: 'components.crossEntityTabs.schema.showBasketButton',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'itemsRowDesktop',
      label: 'schema.items.visibleItemsDesktop',
      type: 'number',
      min: 1,
      groupingName: 'schema.items',
      default: 4
    },
    {
      formControlName: 'itemsRowTablet',
      label: 'schema.items.visibleItemsTablet',
      type: 'number',
      min: 1,
      groupingName: 'schema.items',
      default: 3
    },
    {
      formControlName: 'itemsRowMobile',
      label: 'schema.items.visibleItemsMobile',
      type: 'number',
      min: 1,
      groupingName: 'schema.items',
      default: 2
    }
  ]
};
